import React from "react";
import BootstrapTable from "react-bootstrap-table-next";

import { Button as ReactButton, Row } from "react-bootstrap";
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group'; // ES6
import "../static/css/TableCell.css";
import cellEditFactory from "react-bootstrap-table2-editor";
import $ from "jquery";
import { Button, Form, Input, InputNumber, Select, Switch } from "antd";
import { CloudDownloadOutlined, DisconnectOutlined, LinkOutlined, ReloadOutlined } from "@ant-design/icons";
import { DraggableModal, DraggableModalProvider } from "ant-design-draggable-modal";
import openNotificationWithIcon from "../utils/Tools";
import ConfigGetter from "../utils/ConfigGetter";

const { Option } = Select;
const cnf = ConfigGetter.getConfig();
const globalEditingMap = {};

let DING_AUDIO = [
    new Audio("https://www.foreseem.com/audio/catoo.mp3"),
    new Audio("https://www.foreseem.com/audio/ding.mp3"),
];

let is_playing = false;

let animation = {};
let sound_key = {};

const playWarningTone = (key, value, sound_index = 0) => {
    if (global.warningTone && is_playing === false) {
        is_playing = true;
        DING_AUDIO[sound_index].play()
            .then(() => {
                setTimeout(() => is_playing = false, 500);
            })
            .catch((e) => {
                setTimeout(() => is_playing = false, 500);
                DING_AUDIO = [
                    new Audio("https://www.foreseem.com/audio/catoo.mp3"),
                    new Audio("https://www.foreseem.com/audio/ding.mp3"),
                ];
                openNotificationWithIcon(false, `Sound Alert`, `Failed to play sound:\r\n${e.message}`);
            });
        // setTimeout(() => is_playing = false, 5000);
    }

    if (global.notification) {
        let msg = "Notification";
        let des = key && value ? `${key.split("||")[0]}\r\n${key.split("||")[1]}:\r\n${value}` : "";

        // let msg = `Notification` + ( key && value ? `: ${key.split('||')[0]}` : '');
        // let des = key && value ? `${key.split('||')[1]}: ${value}` : ''l
        if (des) {
            openNotificationWithIcon("info", msg, des);
        }
    }
};

class PortfolioTable extends React.Component {
    constructor (props) {
        super(props);

        this.tableName = props.tableName;
        this.formRef = React.createRef();
        this.transferRef = new Map();
        this.transferReceived = {};

        this.tableElement = props.tableElement;

        if (globalEditingMap[this.tableName] === undefined) {
            globalEditingMap[this.tableName] = new Map();
        }

        if (props.dataStructure.rows === undefined) {
            props.dataStructure.rows = [];
            setTimeout(() => alert(`Invalid Table Config:  ${props.tabName}->${props.tableName}`), 3000);
        }

        this.account = undefined;

        if (typeof props.tableName === "string" && props.tableName.includes("ACT_")) {
            let info = props.tableName.split("_");
            let act_index = info.indexOf("ACT");
            this.account = info.slice(act_index, act_index + 2).join("_");
        }
        else if (typeof props.tabName === "string" && props.tabName.includes("ACT_")) {
            let info = props.tabName.split("_");
            let act_index = info.indexOf("ACT");
            this.account = info.slice(act_index, act_index + 2).join("_");
        }

        this.columnEditorMap = new Map();
        let columns = new Set();
        let rowKeys = new Set();
        props.dataStructure.rows.forEach(rowConfig => {
            for (const key of Object.keys(rowConfig)) {
                let lastSplitIndex = key.lastIndexOf("|");
                rowKeys.add(key.substring(0, lastSplitIndex));

                let column = key.substring(lastSplitIndex + 1);
                columns.add(column);
                rowConfig[key] && this.columnEditorMap.set(column, rowConfig[key]);
            }
        });

        let formatColumns = [{
            dataField: "rowKey",
            text: "Key",
            title: true,
            formatter: this.cellFormatter,
            formatExtraData: props.tableName,
        }];
        columns.forEach((column) => {
            if (this.columnEditorMap.has(column)) {
                let type = this.columnEditorMap.get(column);
                try {
                    let editor_config = this.get_editor_config(type, column);
                    formatColumns.push(editor_config);
                } catch (e) {
                    openNotificationWithIcon(false, "Error", e.message);
                    console.log(e.stack);
                    $.ajax({
                        method: "post",
                        url: `${cnf["restUrl"]}/notification`,
                        data: {
                            Name: "ErrorReport",
                            Message: e.stack,
                        }
                    });
                }
            }
            else {
                formatColumns.push({
                    dataField: column,
                    text: column,
                    formatter: this.cellFormatter,
                    formatExtraData: props.tableName,
                    editable: false
                });
            }
        });

        this.state = {
            modalVisible: false,
            columns: formatColumns,
            data: props.data.rows.map((row, ix) => {
                let newRow = {};

                let row_key = this.tableElement["rowKeys"][ix];

                if (row_key === "") {
                    newRow["rowKey"] = "".padStart(ix, " ");
                }
                else {
                    newRow["rowKey"] = row_key;
                }

                this.tableElement["columns"].forEach((col) => {
                    newRow[col] = this.props.showNullValue ? null : row[`${row_key}|${col}`];
                });

                return newRow;
            }),
            cellEdit: cellEditFactory({
                mode: "dbclick",
                blurToSave: true,
                onFocus: false,
            })
        };

        // this.cellEdit = cellEditFactory({
        //     mode: 'dbclick',
        //     blurToSave: true,
        //     // afterSaveCell: this.afterSaveCell,
        //     // beforeSaveCell: this.beforeSaveCell,
        //     onFocus: false,
        // });
    }

    getItem (item) {
        let arr = [];
        Object.keys(item).forEach(x => {
            if (item[x] === "inputNumber") {
                arr.push(
                    <Form.Item key={x} label={x} name={x} rules={[{ required: true }]}>
                        <InputNumber id={"coinQuantity"} style={{ width: "100%" }}
                                     onChange={(value) => this.transferRef.set(x, value)}/>
                    </Form.Item>
                );
            }
            else if (item[x] === "switch") {
                arr.push(
                    <Form.Item key={x} label={x} name={x} rules={[{ required: false }]}>
                        <Switch id={"switching"} defaultChecked={false}
                                onClick={(checked => {this.transferRef.set(x, checked);})}/>
                    </Form.Item>
                );
            }
            else if (item[x] === "input") {
                arr.push(
                    <Form.Item key={x} label={x} name={x} rules={[{ required: true }]}>
                        <Input id={"inputting"} onChange={(e) => this.transferRef.set(x, e.target.value)}/>
                    </Form.Item>
                );
            }
            else if (Array.isArray(item[x]) === true && item[x].length > 0) {
                if (item[x].length === 1) {
                    this.transferRef.set(x, item[x][0]);
                }
                arr.push(
                    <Form.Item key={x} label={x} name={x} rules={[{ required: true }]}
                               initialValue={item[x].length === 1 ? item[x][0] : ""}>
                        <Select defaultValue={item[x].length === 1 ? item[x][0] : ""} optionFilterProp={"label"}
                                onChange={(value) => this.transferRef.set(x, value)}>
                            {item[x].map((e => <Option key={e} title={x} value={e}>{e}</Option>))}
                        </Select>
                    </Form.Item>);
            }
        });
        return arr;
    };

    get_editor_config (type, columnName) {
        let column_type = this.columnEditorMap.get(columnName);
        let baseObj = {
            dataField: columnName,
            text: columnName,
            formatter: this.get_cell_formatter(columnName),
            formatExtraData: ["sound", "sound0", "sound1"].includes(column_type) ? `${this.props.tableName}||${columnName}` : this.props.tableName,
            editable: true
        };

        const selectRenderer = (editorProps, value, row, column, rowIndex, columnIndex) => {
            let updateConfig = (v) => {
                if (v) {
                    editorProps.onUpdate(v);
                    this.sendRequestToStrategy({
                        table: this.props.tableName,
                        row: row["rowKey"],
                        column: column["dataField"],
                        value: v,
                        account: this.account,
                        user: localStorage.getItem("username")
                    });
                }
                else {
                    editorProps.onUpdate(v);
                }
            };

            let info = value ? JSON.parse(value) : { name: undefined, options: [] };
            let default_value = info["name"] || "-";
            let options = info["options"].map(x => <Select.Option value={x}>{x}</Select.Option>);
            let longest_length = Math.max(5, ...info["options"].map(o => o.length));
            let width = longest_length * 12 + "px";

            return <Select defaultValue={default_value}
                           disabled={default_value === "-"}
                           maxTagCount={10}
                           style={{ width: width }}
                           bordered={false}
                           autoFocus={false}
                           onBlur={() => editorProps.onUpdate(info["name"] || "-")}
                           onSelect={(v) => {
                               updateConfig(v);
                           }}
            >
                {options}
            </Select>;
        };

        const inputRender = (editorProps, value, row, column, rowIndex, columnIndex) => {
            if (typeof value === "string" && value.includes("{") && value.includes("}") && value.includes("name") && value.includes("options")) {
                return selectRenderer(editorProps, value, row, column, rowIndex, columnIndex);
            }

            let updateConfig = () => {
                if (globalEditingMap[this.tableName].has(`${column["dataField"]}@${rowIndex}`)) {
                    editorProps.onUpdate(globalEditingMap[this.tableName].get(`${column["dataField"]}@${rowIndex}`));
                    this.sendRequestToStrategy({
                        table: this.props.tableName,
                        row: row["rowKey"],
                        column: column["dataField"],
                        value: globalEditingMap[this.tableName].get(`${column["dataField"]}@${rowIndex}`),
                        account: this.account,
                        user: localStorage.getItem("username")
                    });
                    setTimeout(() => globalEditingMap[this.tableName].clear(), 5000);
                }
                else {
                    editorProps.onUpdate(value);
                }
                this.isEditing = false;
            };

            this.isEditing = true;
            if (this.editingTimeout) {
                clearTimeout(this.editingTimeout);
            }
            this.editingTimeout = setTimeout(() => updateConfig(), 30000);

            let longest_length = Math.max(8, (value || "").length);
            let width = longest_length * 10 + "px";

            return <Input defaultValue={value}
                          style={{ width: width }}
                          autoFocus={true}
                          bordered={true}
                          status="warning"
                          onChange={(e) => {
                              this.isEditing = true;
                              value = e.target.value;
                              globalEditingMap[this.tableName].set(`${column["dataField"]}@${rowIndex}`, e.target.value);
                              if (this.editingTimeout) {
                                  clearTimeout(this.editingTimeout);
                              }
                              this.editingTimeout = setTimeout(() => updateConfig(), 30000);
                          }}
                          onBlur={updateConfig}
                          onPressEnter={updateConfig}
            />;
        };

        switch (type) {
            case "switch":
                return Object.assign(baseObj, {
                    editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => (
                        <Switch defaultChecked={["-", "OFF"].includes(value) === false}
                                autoFocus={false}
                                onClick={(checked => {
                                    this.isEditing = true;
                                    this.sendRequestToStrategy({
                                        table: this.props.tableName,
                                        row: row["rowKey"],
                                        column: column["dataField"],
                                        value: checked,
                                        account: this.account,
                                        user: localStorage.getItem("username")
                                    });

                                    if (this.editingTimeout) {
                                        clearTimeout(this.editingTimeout);
                                    }
                                    this.editingTimeout = setTimeout(() => {
                                        this.isEditing = false;
                                        try {
                                            editorProps.onUpdate(value);
                                        } catch (e) {
                                            openNotificationWithIcon(false, "Error", e.message);
                                        }
                                    }, 1500);
                                })}
                        />
                    )
                });

            case "inputNumber":
                return Object.assign(baseObj, {
                    editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => {
                        let default_value = "0.00";
                        let tag = "%";
                        let step = 0.01;
                        if (!isNaN(+(value || "").replace("%", ""))) {
                            default_value = (+((value || "").replace("%", "")));
                        }
                        else if (!isNaN(+(value || "").slice(0, -1))) {
                            tag = (value || "%").slice(-1);
                            default_value = (+((value || "").slice(0, -1)));
                            step = 1;
                        }
                        // let default_value = isNaN(+(value || '').replace(tag, '')) ? '0.00' : (+((value || '').replace(tag, '')));
                        if (default_value === "0.00") {
                            if (column["dataField"] === "avg_enter") {
                                default_value = "-0.02";
                                globalEditingMap[this.tableName].set(`${column["dataField"]}@${rowIndex}`, default_value + tag);
                            }
                            else if (column["dataField"] === "avg_exit") {
                                default_value = "0.02";
                                globalEditingMap[this.tableName].set(`${column["dataField"]}@${rowIndex}`, default_value + tag);
                            }
                        }

                        let updateConfig = () => {
                            if (globalEditingMap[this.tableName].has(`${column["dataField"]}@${rowIndex}`)) {
                                let number = globalEditingMap[this.tableName].get(`${column["dataField"]}@${rowIndex}`) || "0";
                                if (isNaN(+(number.replace(tag, "")))) {
                                    openNotificationWithIcon(false, "Error", `Invalid number: ${number}`);
                                    setTimeout(() => globalEditingMap[this.tableName].clear(), 5000);
                                    return;
                                }
                                editorProps.onUpdate(number);
                                this.sendRequestToStrategy({
                                    table: this.props.tableName,
                                    row: row["rowKey"],
                                    column: column["dataField"],
                                    value: number.replace(tag, ""),
                                    account: this.account,
                                    user: localStorage.getItem("username")
                                });
                                setTimeout(() => globalEditingMap[this.tableName].clear(), 5000);
                            }
                            else {
                                editorProps.onUpdate(value);
                            }
                            this.isEditing = false;
                        };

                        this.isEditing = true;
                        if (this.editingTimeout) {
                            clearTimeout(this.editingTimeout);
                        }
                        this.editingTimeout = setTimeout(() => updateConfig(), 15000);

                        return <InputNumber defaultValue={default_value} step={step} size={"large"}
                                            autoFocus={true}
                                            bordered={true}
                                            status="warning"
                            // formatter={v => `${v}`}
                            // parser={v => v.replace(tag, '')}
                                            onChange={((v) => {
                                                this.isEditing = true;
                                                globalEditingMap[this.tableName].set(`${column["dataField"]}@${rowIndex}`, v + tag);
                                                if (this.editingTimeout) {
                                                    clearTimeout(this.editingTimeout);
                                                }
                                                this.editingTimeout = setTimeout(() => updateConfig(), 15000);
                                            })}
                                            onBlur={updateConfig}
                                            onPressEnter={updateConfig}
                        />;
                    }
                });

            case "button":
                return Object.assign(baseObj, {
                    editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => (
                        <Button danger type={"primary"} size="small" autoFocus={false}
                                onClick={(() => { //{editorProps.onBlur}
                                    this.isEditing = true;
                                    this.sendRequestToStrategy({
                                        table: this.props.tableName,
                                        row: row["rowKey"],
                                        column: column["dataField"],
                                        value: value || "button",
                                        account: this.account,
                                        user: localStorage.getItem("username")
                                    });
                                    if (this.editingTimeout) {
                                        clearTimeout(this.editingTimeout);
                                    }
                                    this.editingTimeout = setTimeout(() => {
                                        this.isEditing = false;
                                        // editorProps.onUpdate(value)  // TODO: fix bug here
                                    }, 1500);
                                })}
                        >{value || "button"}</Button>
                    )
                });

            case "popups":
                return Object.assign(baseObj, {
                    editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => {
                        let obj;
                        try {
                            obj = JSON.parse(value);
                            if (typeof obj === "number") {
                                return inputRender(editorProps, value, row, column, rowIndex, columnIndex);
                            }
                        } catch (e) {
                            return inputRender(editorProps, value, row, column, rowIndex, columnIndex);
                        }

                        let displayContent = obj["display"] || obj["name"];

                        return (
                            <DraggableModalProvider>
                                <Button type="primary" size={"small"}
                                        onClick={() => {
                                            this.transferReceived = JSON.parse(JSON.stringify(obj));
                                            // Object.assign(this.transferReceived, obj)
                                            this.setState({ modalVisible: true });

                                            setTimeout(() => {
                                                // this.isEditing = true;   // keep ui table refreshing when open modal
                                                if (this.editingTimeout) {
                                                    clearTimeout(this.editingTimeout);
                                                }
                                                this.editingTimeout = setTimeout(() => this.isEditing = false, 600000);
                                            }, 500);
                                        }}>
                                    {displayContent}
                                </Button>
                                <DraggableModal title={obj["name"]} visible={this.state.modalVisible}
                                                onOk={() => {
                                                    $.ajax({
                                                        method: "post",
                                                        url: `${cnf["restUrl"]}/update_config/${localStorage.getItem("username")}`,
                                                        data: Object.assign(Object.fromEntries(this.transferRef.entries()), {
                                                            user: localStorage.getItem("username"),
                                                            name: this.transferReceived["name"],
                                                            ref_id: this.transferReceived["ref_id"]
                                                        }),
                                                        success: (res) => {
                                                            openNotificationWithIcon(true, "Success", res);
                                                        },
                                                        error: (res) => {
                                                            openNotificationWithIcon(false, "Error", res);
                                                        }
                                                    });
                                                }}
                                                onCancel={() => {
                                                    this.isEditing = false;
                                                    this.transferRef.clear();
                                                    this.transferReceived = {};
                                                    this.setState({ modalVisible: false });
                                                }}
                                                destroyOnClose={true} okText={obj["name"]}
                                >
                                    <Form ref={this.formRef} name={obj["name"]} labelCol={{ span: 5 }}>
                                        {this.getItem(this.transferReceived)}
                                    </Form>
                                </DraggableModal>
                            </DraggableModalProvider>
                        );
                    }
                });

            case "select":
            case "selector":
                return Object.assign(baseObj, {
                    editorRenderer: selectRenderer
                });

            case "sound":
            case "sound0":
            case "sound1":
            case "input":
            default:
                return Object.assign(baseObj, {
                    editorRenderer: inputRender
                });
        }
    }

    sendRequestToStrategy (data) {
        if (data["row"] && data["row"].includes("--") === false) {
            $.ajax({
                method: "post",
                url: `${cnf["restUrl"]}/update_config/${data["user"]}`,
                timeout: 8000, // sets timeout to 10 seconds
                data: data,
                success: (res) => {
                    openNotificationWithIcon(true, "Success", res);
                },
                error: (res) => {
                    openNotificationWithIcon(false, "Error", res);
                    // setTimeout(() => this.sendRequestToStrategy(data), 3000);
                }
            });
        }
        else {
            openNotificationWithIcon(false, "Error", `Invalid row key: ${data["row"]}`);
        }
    }

    switchAnimation (tableName) {
        if (global.animation) {
            animation[tableName] = !animation[tableName];
        }
    }

    switchWarningTone () {
        if (global.warningTone) {
            global.warningTone = false;
            openNotificationWithIcon(false, `Sound Alert: Turn off Audio`);
        }
        else {
            global.warningTone = true;
            is_playing = false;
            playWarningTone();
            openNotificationWithIcon(true, `Sound Alert: Turn on Audio`);
        }
    }

    get_cell_formatter (columnName) {
        let column_type = this.columnEditorMap.get(columnName);

        if (["popups", "select", "selector", "input"].includes(column_type)) {
            return this.ObjectFormatter;
        }
        else if (["_state", "avg_e", "enter_t", "exit_t"].some(i => columnName.includes(i)) || ["red"].includes(column_type)) {
            return this.cellAlarmFormatter;
        }
        else if (["sound", "sound0"].includes(column_type)) {
            return this.cellSoundFormatter;
        }
        else if (["sound1"].includes(column_type)) {
            return this.cellSound1Formatter;
        }
        else if (["carousel"].includes(columnName)) {
            return this.cellFormatter2;
        }
        else if (["multiline"].includes(column_type)) {
            return this.cellMultiLineFormatter;
        }
        else if (["monospace"].includes(column_type)) {
            return this.cellMonospaceFormatter;
        }
        else {
            return this.cellFormatter;
        }
    }

    cellFormatter (content, row, rowIdx, formatExtraData) {
        // TODO: transitionAppear? transitionEnter?
        if (global.animation && !!animation[formatExtraData]) {
            return (
                // <div>
                //     <ReactCSSTransitionGroup transitionName='numChanging' transitionAppear={true}
                //                              transitionAppearTimeout={500} transitionEnter={false} transitionLeave={false} >
                //         <div className='singleLineCell' key={`${formatExtraData}-${rowIdx}-${content}`}>
                //             {content}
                //         </div>
                //     </ReactCSSTransitionGroup>
                // </div>
                <div className="cellInfoChanging" key={`${formatExtraData}-${rowIdx}`}>
                    {content}
                </div>
            );
        }
        else {
            return (<div className="singleLineCell" key={`${formatExtraData}-${rowIdx}`}>
                {content}
            </div>);
        }
    }

    cellFormatter2 (content, row, rowIdx, formatExtraData) {
        if (global.animation) {
            return (
                <div className="singleLineCell" key={`${formatExtraData}-${rowIdx}`}>
                    {content}
                </div>
            );
        }
        else {
            return (<div className="singleLineCell" key={`${formatExtraData}-${rowIdx}`}>
                {content}
            </div>);
        }
    }

    cellMultiLineFormatter (content, row, rowIdx, formatExtraData) {
        // TODO: transitionAppear? transitionEnter?
        if (global.animation && !!animation[formatExtraData]) {
            return (
                <div className="multiLineCell" key={`${formatExtraData}-${rowIdx}`}>
                    {content}
                </div>
            );
        }
        else {
            return (<div className="multiLineCell" key={`${formatExtraData}-${rowIdx}`}>
                {content}
            </div>);
        }
    }

    cellMonospaceFormatter (content, row, rowIdx, formatExtraData) {
        // TODO: transitionAppear? transitionEnter?
        if (global.animation && !!animation[formatExtraData]) {
            return (
                <div className="monospaceCell" key={`${formatExtraData}-${rowIdx}`}>
                    {content}
                </div>
            );
        }
        else {
            return (<div className="monospaceCell" key={`${formatExtraData}-${rowIdx}`}>
                {content}
            </div>);
        }
    }

    cellSoundFormatter (content, row, rowIdx, formatExtraData) {
        let sk = formatExtraData.replace("||", `||${row["rowKey"]}=>`);
        if (sound_key[sk] === undefined) {
            sound_key[sk] = content;
            if (content && formatExtraData.includes("last_e")) {
                playWarningTone(sk, content);
            }
        }
        else if (content && (sound_key[sk] !== content)) {
            playWarningTone(sk, content);
        }
        sound_key[sk] = content;

        return (
            <div className="cellWarnChanging" key={`${formatExtraData}-${rowIdx}`}>
                {content}
            </div>);
    }

    cellSound1Formatter (content, row, rowIdx, formatExtraData) {
        let sk = formatExtraData.replace("||", `||${row["rowKey"]}=>`);
        if (sound_key[sk] === undefined) {
            sound_key[sk] = content;
            if (content && formatExtraData.includes("last_e")) {
                playWarningTone(sk, content, 1);
            }
        }
        else if (content && (sound_key[sk] !== content)) {
            playWarningTone(sk, content, 1);
        }
        sound_key[sk] = content;

        return (
            <div className="cellWarnChanging" key={`${formatExtraData}-${rowIdx}`}>
                {content}
            </div>);
    }

    cellAlarmFormatter (content, row, rowIdx, formatExtraData) {
        if (global.animation) {
            return (
                <div className="cellRedChanging" key={`${formatExtraData}-${rowIdx}`}>
                    {content}
                </div>
            );
        }
        else {
            return (<div className="singleLineCell" key={`${formatExtraData}-${rowIdx}`}>
                {content}
            </div>);
        }

    }

    ObjectFormatter (content, row, rowIdx, formatExtraData) {
        let display = "";
        if (typeof content === "undefined") {
            display = "";
        }
        else if (typeof content === "string") {
            if (content.startsWith("{\"")) {
                let data = JSON.parse(content);
                display = data["display"] || data["name"];
            }
            else {
                display = content;
            }
        }
        else if (typeof content === "number") {
            display = String(content);
        }

        if (!!animation[formatExtraData] && global.animation) {
            return (
                <div className="cellInfoChanging" key={`${formatExtraData}-${rowIdx}`}>
                    {display}
                </div>
            );
        }
        else {
            return (
                <div className="singleLineCell" key={`${formatExtraData}-${rowIdx}`}>
                    {display}
                </div>
            );
        }
    }

    componentWillMount () {
        // pass
    }

    shouldComponentUpdate (nextProps, nextState) {
        return !this.isEditing;
    }

    componentWillReceiveProps () {
        this.state.data = this.props.data.rows.map((row, ix) => {
            let newRow = {};

            let row_key = this.tableElement["rowKeys"][ix];

            if (row_key === "") {
                newRow["rowKey"] = "".padStart(ix, " ");
            }
            else {
                newRow["rowKey"] = row_key;
            }

            this.tableElement["columns"].forEach((col) => {
                newRow[col] = this.props.showNullValue ? null : row[`${row_key}|${col}`];
            });

            return newRow;
        });
    }

    render () {
        // stick the new editing value in cell for three seconds
        Array.from(globalEditingMap[this.tableName].keys()).forEach((k) => {
            let [dataField, rowIndex] = k.split("@");
            if (this.state.data[+rowIndex] && this.state.data[+rowIndex][dataField] && globalEditingMap[this.tableName].has(k)) {
                this.state.data[+rowIndex][dataField] = globalEditingMap[this.tableName].get(k);
            }
        });

        // const odd_second = new Date().getSeconds() % 2 === 1;
        const timeAlarm = !this.props.data.updatedAt || (Date.now() - this.props.data.updatedAt > (this.props.data.latency || 60000));
        const cn = timeAlarm ? "timeAlarm" : undefined;

        return (<Row style={this.props.style}>
                <h3 style={{ marginTop: "10px", float: "left" }}>
                    {<ReactButton className="label label-default"
                                  style={{ padding: "3.6px,10.8px,5.4px", height: "32.99px" }}
                                  onClick={() => this.switchAnimation(this.props.tableName)}
                                  onDoubleClick={() => this.switchWarningTone()}>{this.props.tableName}</ReactButton>}
                </h3>
                <div className={cn} style={{ float: "right", marginTop: "25px" }}>
                    <b style={{ fontSize: "large" }}>{global.ws["readyState"] ? <LinkOutlined/> :
                        <DisconnectOutlined/>}</b> &nbsp;&nbsp;
                    <b style={{ fontSize: "large" }}><CloudDownloadOutlined onClick={() => {
                        global.ws.send(JSON.stringify({ snapshot: true }));
                        openNotificationWithIcon(true, `Request for snapshot successfully.`);
                    }}/></b> &nbsp;&nbsp;
                    <b style={{ fontSize: "larger" }}><ReloadOutlined spin={global.ws["closing"]} onClick={() => {
                        global.ws.close();
                        openNotificationWithIcon(true, `Reconnecting ...`);
                    }}/></b> &nbsp;&nbsp;
                    <b>Update</b>: {this.props.data.updatedAt ? new Date(this.props.data.updatedAt).toTimeString().substring(0, 8) : ""} &nbsp;
                    <b>Send</b>: {this.props.data.sendAt ? new Date(this.props.data.sendAt).toTimeString().substring(0, 8) : ""} &nbsp;
                    <b>Render</b>: {new Date().toTimeString().substring(0, 8)}
                </div>
                <div style={{ marginTop: "60px", "overflowX": "auto" }}>
                    <BootstrapTable bordered striped hover cellEdit={this.state.cellEdit} key={this.props.tableName}
                                    keyField="rowKey" data={this.state.data}
                                    columns={this.state.columns} noDataIndication="Empty Table"/></div>
            </Row>
        );
    }
}

export default class PortfolioTables extends React.Component {
    render () {
        let portfolioTableNames = Object.keys(this.props.dataStructure);

        return (<div>
            {portfolioTableNames.map((tableName, index) => {
                let showNullValue = false;
                if (!this.props.data[tableName]) {
                    showNullValue = true;
                }
                const data = showNullValue ? this.props.dataStructure[tableName] : this.props.data[tableName];
                return (<PortfolioTable key={index + "_single_table"}
                                        data={data}
                                        tableElement={this.props.tableElement[tableName]}
                                        dataStructure={this.props.dataStructure[tableName]}
                                        tableName={tableName}
                                        tabName={this.props.tabName}
                                        showNullValue={showNullValue}
                                        style={this.props.style}
                />);
            })}</div>);
    }
}



// WEBPACK FOOTER //
// ./src/component/portfolio-table.js